import { Component, OnInit, Input, EventEmitter } from '@angular/core';
import {MaterializeAction} from 'angular2-materialize';

@Component({
  selector: 'donation-card',
  templateUrl: './donation-card.component.html',
  styleUrls: ['./donation-card.component.css']
})
export class DonationCardComponent implements OnInit {

  @Input() header: string
  @Input() subheader: string
  @Input() address: string
  @Input() qrcode: string


  constructor() { }

  ngOnInit() {
  }

  clickActions = new EventEmitter<string | MaterializeAction>();
  openToast(){
    console.log("Clicked")
    this.clickActions.emit({action:"toast", params:['Address Coppied', 3000]})
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src946329470/src/frontend/src/app/donation/donation-card/donation-card.component.ts